
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/posts/[categorySlug]/[postSlug]",
      function () {
        return require("private-next-pages/posts/[categorySlug]/[postSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/posts/[categorySlug]/[postSlug]"])
      });
    }
  